import { render, staticRenderFns } from "./SharedEvent.vue?vue&type=template&id=b6425e24&"
import script from "./SharedEvent.vue?vue&type=script&lang=js&"
export * from "./SharedEvent.vue?vue&type=script&lang=js&"
import style0 from "./SharedEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports